import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { SrxApi } from '../../api/SrxApi';

const useDeleteDestruction = () => {
    const { mutate: deleteDestruction, isLoading } = useMutation(
        async (itemIds) => {
            await Promise.all(itemIds.map((id) => SrxApi.delete(`/destructions/${id}`)));
        },
        {
            onSuccess: () => {
                toast.success('Destruction deleted successfully!');
            },
            onError: (error) => {
                const errorMessage =
                    error?.response?.data?.message || error?.message || 'Failed to delete destruction';
                toast.error(errorMessage);
            },
        }
    );

    return {
        deleteDestruction,
        isDeleteDestructionLoading: isLoading,
    };
};

export default useDeleteDestruction;
